export default __webpack_public_path__ + "static/media/ShortlistBlip.48f1a800.svg";